import { SurveyDto } from '../backend/backendapi';

export class CookieUtils {
  public static hasCookie(name: string, value: string): boolean {
    let found = false;
    document.cookie.split(';').forEach(function (e) {
      const cookie = e.split('=');
      if (name == cookie[0].trim() && (!value || value == cookie[1].trim())) {
        found = true;
      }
    });
    return found;
  }

  public static tryGetCookie(name: string): string | undefined {
    let retObj: string | undefined = undefined;
    document.cookie.split(';').forEach(function (e) {
      const cookie = e.split('=');
      if (name == cookie[0].trim() && retObj === undefined) {
        retObj = decodeURIComponent(cookie[1].trim());
      }
    });
    return retObj;
  }

  public static releaseCookie(name: string): void {
    const date = new Date();
    date.setTime(date.getTime() + 5000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=true; path=/; SameSite=None; Secure;' + expires;
  }
}

export function getLocalizedSurveyName(surveyNames: { [key: string]: string }, fallback: string, locale: string): string {
  const simpleLocale = locale.split('-')[0];
  return (Object.keys(surveyNames).includes(locale) ? surveyNames[locale] : undefined)
    ?? (Object.keys(surveyNames).includes(simpleLocale) ? surveyNames[simpleLocale] : undefined)
    ?? (Object.keys(surveyNames).includes('default') ? surveyNames['default'] : undefined)
    ?? fallback;
}

export function getLocalizedSurveyNameFromSurvey(survey: SurveyDto | undefined, fallback: string, locale: string): string {
  let surveyNames = JSON.parse(survey?.json ?? '{}')?.title ?? {};
  if (!(surveyNames instanceof Object)) {
    surveyNames = { 'default': surveyNames.toString() };
  }
  return getLocalizedSurveyName(surveyNames, survey?.name ?? fallback, locale);
}